import { createContext, useCallback, useContext, useRef, useState } from 'react';

const ToastContext = createContext(null);

const DURACAO_PADRAO_MS = 6000;
let proximoId = 1;

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);
  const timers = useRef({});

  const remover = useCallback((id) => {
    setToasts((atual) => atual.filter((t) => t.id !== id));
    clearTimeout(timers.current[id]);
    delete timers.current[id];
  }, []);

  // `tipo`: 'sucesso' | 'erro' | 'info'. Toda notificação do painel passa
  // por aqui (pedido por Jason 2026-09-19: "todas as notificações devem
  // ser Toast") — nunca mais um `<Alert>` solto dentro da página.
  const notificar = useCallback(
    (mensagem, tipo = 'info', duracaoMs = DURACAO_PADRAO_MS) => {
      const id = proximoId++;
      setToasts((atual) => [...atual, { id, mensagem, tipo }]);
      if (duracaoMs > 0) {
        timers.current[id] = setTimeout(() => remover(id), duracaoMs);
      }
      return id;
    },
    [remover]
  );

  const valor = {
    toasts,
    remover,
    notificar,
    sucesso: (mensagem, duracaoMs) => notificar(mensagem, 'sucesso', duracaoMs),
    erro: (mensagem, duracaoMs) => notificar(mensagem, 'erro', duracaoMs ?? 10000),
    info: (mensagem, duracaoMs) => notificar(mensagem, 'info', duracaoMs),
  };

  return <ToastContext.Provider value={valor}>{children}</ToastContext.Provider>;
}

export function useToast() {
  return useContext(ToastContext);
}
